import type { App } from 'vue'
import { useSignalR } from '@/composables/useSignalR'
import { getMsalInitialized } from './auth/msalConfig'

export default function (_app: App) {
  const { connect } = useSignalR()

  const initSignalR = async () => {
    const maxWaitTime = 10000
    const checkInterval = 100
    let waited = 0

    while (!getMsalInitialized() && waited < maxWaitTime) {
      await new Promise(resolve => setTimeout(resolve, checkInterval))
      waited += checkInterval
    }

    if (getMsalInitialized()) {
      await connect()
    }
  }

  initSignalR()
}
